/** Up to two capital letters for a person's avatar, e.g. "Peter Hevesi" → "PH". */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
}
